

import { Live2DCubismFramework as live2dcubismframework } from './Framework/src/live2dcubismframework';
import CubismFramework = live2dcubismframework.CubismFramework;
import { Live2DCubismFramework as cubismusermodel } from './Framework/src/model/cubismusermodel';
import CubismUserModel = cubismusermodel.CubismUserModel;

export class AppCubismUserModel extends CubismUserModel {
  constructor() {
      super();
  }

  /**
   * モデルのパラメータを更新する
   * @param ParamMouthForm  口変形 +で笑った口 -で怒った口
   * @param ParamMouthOpenY 口開閉 +で口を開く
   * @param ParamEyeROpen 右目開閉 +で目を開ける
   * @param ParamEyeLOpen 左眼開閉 +で目を開ける
   * @param ParamAngleX 角度X  +で画面の右を向く
   * @param ParamAngleY 角度Y  +で画面の上を向く
   * @param ParamAngleZ 角度Z  +で画面の右を向く
   */
  public update(ParamMouthForm, ParamMouthOpenY, ParamEyeROpen, ParamEyeLOpen, ParamAngleX, ParamAngleY, ParamAngleZ, ParamBreath, ParamBodyAngleZ) {
    // console.log('ParamMouthForm: ', ParamMouthForm);
    // console.log('ParamMouthOpenY: ', ParamMouthOpenY);
    // console.log('ParamEyeROpen: ', ParamEyeROpen);
    // console.log('ParamEyeLOpen: ', ParamEyeLOpen);
    // console.log('ParamAngleX: ', ParamAngleX);
    // console.log('ParamAngley: ', ParamAngleY);
    // console.log('ParamAngleZ: ', ParamAngleZ);
    // console.log('ParamBreath: ', ParamBreath);
    // console.log('ParamBodyAngleZ: ', ParamBodyAngleZ);

    // ポーズ
    if (this._pose !== null) {
      this._pose.updateParameters(this._model, 0);
    }

    // 表情
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamMouthForm'), ParamMouthForm + 0.7);
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamMouthOpenY'), ParamMouthOpenY);
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamEyeROpen'), -(ParamEyeROpen - 1));
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamEyeLOpen'), -(ParamEyeLOpen - 1));

    // 頭の角度
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamAngleX'), ParamAngleX * 100);
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamAngleY'), -(ParamAngleZ * 100 - 15));
    // this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamAngleZ'), ParamAngleZ);

    // 呼吸
    this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamBreath'), ParamBreath);
    // // 体の傾き
    // this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamBodyAngleZ'), ParamBodyAngleZ);
    // this._model.setParameterValueById(CubismFramework.getIdManager().getId('ParamBodyAngleX'), ParamBodyAngleZ);

    this._model.update();

  }
}
